export default () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
